<template>
  <div class="relative p-6 border rounded" :class="request.container">
    <h3 class="flex items-center mb-2">
      <icon
        v-if="request.icon"
        :icon="request.icon"
        class="w-6 h-6 mr-2"
        :class="request.icon_class"
      />
      {{ request.status }}
    </h3>
    <p>
      <b>{{ item.request.option.category }}:</b>
      {{ item.request.option.request_type }}
    </p>
    <template v-if="isStaffingItem">
      <dl class="definition-table">
        <dt>Name</dt>
        <dd>{{ get('name') }}</dd>
        <dt>Job Title</dt>
        <dd>{{ get('job_title') }}</dd>
        <dt>Gross Annual Salary</dt>
        <dd>£{{ get('salary').toLocaleString() }}</dd>
        <dt>Employer NIC</dt>
        <dd>£{{ get('employer_nic').toLocaleString() }}</dd>
        <dt>Employer Pension</dt>
        <dd>£{{ get('employer_pension').toLocaleString() }}</dd>
        <dt>Medical Health Premiums</dt>
        <dd>£{{ get('medical_health_premiums').toLocaleString() }}</dd>
        <dt>Life Assurance Premiums</dt>
        <dd>£{{ get('life_assurance_premiums').toLocaleString() }}</dd>
        <dt>Gross Employee Cost</dt>
        <dd>£{{ get('gross_employee_cost').toLocaleString() }}</dd>
        <dt>Breakdown</dt>
        <dd>
          £{{ get('day_rate') }} per day /
          £{{ get('hourly_rate') }} per hour
        </dd>
        <dt>Message</dt>
        <dd>{{ get('message') }}</dd>
      </dl>
    </template>
    <p v-else-if="item.message" class="text-sm italic" v-html="item.message" />
    <template v-if="item.request.message">
      <hr class="border-current" />
      <p>
        <strong>Reply:</strong>
      </p>
      <p class="text-sm italic" v-html="item.request.message" />
    </template>
    <icon-link
      v-if="item.request.option.upload_required && item.request.file.id"
      icon="cheveron-down-circle"
      :href="
        route('applications.files.download', {
          application: uuid,
          file: item.request.file.id,
          project: 1
        })
      "
      target="_blank"
    >
      Download file
    </icon-link>
  </div>
</template>

<script>
export default {
  name: "LogListItemText",
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    uuid() {
      return window._project;
    },
    type() {
      return this.item.request.option.category;
    },
    d() {
      return this.item.request.data;
    },
    isStaffingItem() {
      return this.type === "Staffing";
    },
    request() {
      return {
        Submitted: {
          status: "Change request submitted",
          container: "submitted border-primary-200 bg-primary-100 text-primary-900",
          icon: "refresh",
          icon_class: "icons-primary"
        },
        Approved: {
          status: "Change request approved",
          container: "approved border-positive-200 bg-positive-100 text-positive-900",
          icon: "check",
          icon_class: "icons-positive"
        },
        Rejected: {
          status: "Change request rejected",
          container: "rejected border-negative-200 bg-negative-100 text-negative-900",
          icon: "close-circle",
          icon_class: "icons-negative"
        }
      }[this.item.status ?? "Submitted"];
    }
  },
  methods: {
    get(key) {
      return this.d[key] ?? "";
    }
  }
};
</script>
<style scoped>
.definition-table {
  @apply w-full mb-0 border;
  display: grid;
  grid-template-columns: auto 1fr;
}

.definition-table dt {
  @apply font-semibold text-left;
}

.definition-table dt,
.definition-table dd {
  @apply border;
}

.submitted .definition-table dt {
  @apply bg-primary-200;
}

.submitted .definition-table {
  @apply border-primary-200;
}

.submitted .definition-table dt,
.submitted .definition-table dd {
  @apply py-1 px-2 text-primary-900 border-primary-500;
}

.approved .definition-table dt {
  @apply bg-positive-200;
}

.approved .definition-table {
  @apply border-positive-200;
}

.approved .definition-table dt,
.approved .definition-table dd {
  @apply py-1 px-2 text-positive-900 border-positive-500;
}

.rejected .definition-table dt {
  @apply bg-negative-200;
}

.rejected .definition-table {
  @apply border-negative-200;
}

.rejected .definition-table dt,
.rejected .definition-table dd {
  @apply py-1 px-2 text-negative-900 border-negative-500;
}

</style>
